module.exports = __webpack_public_path__ + "img/41.24e43577.gif";